import React from 'react';
const NavItem = ({toggleType,id,data,active,onClick})=>{
    const className = active?"nav-link active":"nav-link";
    return(
        <li className="nav-item">
            <a className={className} data-toggle={toggleType} href={id} onClick={onClick}>{data}</a>
        </li>
    )
};
export default NavItem;